import * as XLSX from 'xlsx';

type CellValue = string | number;

/** Download a simple .xlsx from the same array-of-arrays used for CSV export. */
export function downloadExcelFromAoa(
  data: Array<Array<CellValue>>,
  filename: string,
  sheetName = 'Report'
): void {
  const safeName = sheetName.replace(/[\\/?*[\]]/g, ' ').slice(0, 31) || 'Report';
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  const maxCols = Math.max(1, ...data.map((row) => row.length));
  worksheet['!cols'] = Array.from({ length: maxCols }, (_, colIndex) => {
    let width = 12;
    data.forEach((row) => {
      const len = String(row[colIndex] ?? '').length;
      if (len + 2 > width) width = len + 2;
    });
    return { wch: Math.min(40, Math.max(10, width)) };
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, safeName);
  XLSX.writeFile(workbook, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
}
